import { getAllowCouponList, getUserCouponList } from '@/apis/base.js';

export default {
  namespaced: true,
  state: () => {
    return {
      // 下单时所有可以使用的优惠券
      allowCouponList: [],
      currentCouponId: '',
      userCouponList: []
    };
  },
  getters: {
    currentCouponItem (state) {
      let result = null;
      state.allowCouponList.forEach(item => {
        if (item.couponsId === state.currentCouponId) result = item;
      });
      return result;
    },
    currentCouponValue (state, getters, rootState, rootGetters) {
      return getters.currentCouponItem ? parseInt(getters.currentCouponItem['couponsValue']) : 0;
    }
  },
  mutations: {
    getAllowCouponList (state, data) {
      state.allowCouponList = data;
    },
    useCouponId (state, data) {
      state.currentCouponId = data;
    },
    getUserCouponList (state, data) {
      state.userCouponList = data;
    }
  },
  actions: {
    async getAllowCouponList ({ commit, rootState }, { productList, recycleType = 0 }) {
      commit('useCouponId', '');
      let ret = await getAllowCouponList({
        productList: JSON.stringify(productList),
        recycleType
      });
      if (ret._errCode === '0') {
        const list = ret._data.couponsList || [];
        // 1439优品渠道，屏蔽不可用优惠券
        if (+rootState.pid === 1439) {
          const filterList = list.filter(e => (+e.isCanUse === 1));
          commit('getAllowCouponList', filterList);
        } else {
          commit('getAllowCouponList', list);
        }
        for (let index = 0; index < list.length; index++) {
          if (list[index]['isCanUse'] === '1') {
            commit('useCouponId', list[index]['couponsId']);
            break;
          }
        }
      }
    },
    async getUserCouponList ({ commit }) {
      let ret = await getUserCouponList({});
      if (ret._errCode === '0') {
        commit('getUserCouponList', ret._data.couponUseLogList);
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/core/coupon/store.js